module.exports = __webpack_public_path__ + "img/study-pro3.a0139fb1.png";